<template>
    <Head title="Ganhadores" />
    <Authenticated>
        <Heading title="Ganhadores" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="component-background-desktop min-h-[70vh]">
            <div class="px-2.5 py-[35px] xl:px-[15vw]">
                <p>
                    Acompanhe os Ganhadores selecionando nos filtros o periodo,
                    campanha, lojas, região ou execução.
                </p>
                <div class="flex items-center gap-x-4">
                    <FilterWinners
                        :campaigns="campaigns"
                        :categories="categories"
                        :seasonWeeks="weeks"
                        @updateFilter="filterGalleries($event)"
                    />
                    <a
                        v-if="isFiltered"
                        class="text-blue-600 hover:underline cursor-pointer text-sm"
                        @click="clearFilter()"
                        >Limpar Filtro</a
                    >
                </div>
                <section class="flex justify-center gap-x-11 gap-y-8 flex-wrap">
                    <div
                        class="border border-primary bg-white rounded-2xl p-4 xl:w-[33vw] w-full"
                        v-for="(item, key) in galleries"
                        :key="key"
                    >
                        <div>
                            <Carousel :photos="item.pictures || []" />
                            <div class="relative">
                                <div
                                    class="absolute right-4 bottom-4 cursor-pointer hover:bg-white"
                                    @click="showInModal(item.pictures)"
                                >
                                    <Icon name="Expandir" />
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 flex justify-start">
                            <div class="flex flex-col gap-y-3">
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Participante
                                    </h1>
                                    <p>{{ item.userCreated?.name }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">Sold</h1>
                                    <p>{{ item.pdv?.codeSoldBroker }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Regional
                                    </h1>
                                    <p>{{ item.pdv?.region }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <pagination :total="total" :limit="limit" @page:selected="setPage($event)"/>
            </div>
        </div>

        <transition v-if="$page.props.flash.error || $page.props.flash.success">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4"
                >
                    <button class="float-right" @click="$page.props.flash = ''">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        {{ $page.props.flash.success ? "Sucesso" : "Erro" }}
                    </h1>
                    <p class="mt-2.5">
                        {{
                            $page.props.flash.success
                                ? $page.props.flash.success
                                : $page.props.flash.error
                        }}
                    </p>
                </div>
            </div>
        </transition>
        <transition v-if="currentReason">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="relative bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4 flex flex-col"
                >
                    <button
                        class="absolute top-2 right-2"
                        @click="currentReason = ''"
                    >
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Possível motivo
                    </h1>
                    <p class="mt-2.5 break-words">{{ currentReason }}</p>
                    <button
                        class="transition-all self-center max-w-[94px] mt-2 p-4 bg-white border border-primary rounded-2xl font-bold text-primary hover:bg-gray-300 hover:border-gray-300"
                        @click="currentReason = ''"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </transition>
        <Gallery :gallery="currentGallery" />
    </Authenticated>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Gallery from "@/Components/Gallery.vue";
import Carousel from "@/Components/CarouselSimple.vue";
import FilterWinners from "@/Components/FilterWinners.vue";
import moment from "moment";
import Pagination from "@/Components/UI/Pagination.vue";

export default {
    components: {
    Authenticated,
    Head,
    Heading,
    Head,
    Icon,
    Button,
    Gallery,
    Carousel,
    FilterWinners,
    Pagination
},

    props: {
        categories: Object,
        campaigns: Object,
        galleries: Object,
        selected: Object,
    },

    data() {
        return {
            galleries: this.galleries?.data || [],
            total: this.galleries?.total || 0,
            limit: 12,
            isFiltered: !!this.filtered,
            filterData: {
                campaign: this.selected.campaign || []
            },
            currentPage: 0,
            currentGallery: "",
            executions: [],
            isLoadingPage: [],
            weeks: [],
            title: "-",
            currentInput: "",
            currentReason: "",
        };
    },

    mounted() {
        const actualWeek = moment().startOf("isoWeek").format("W");
        const MomentWeek = moment()
            .week(actualWeek)
            .startOf("isoWeek")
            .format("W");
        const hotfix = actualWeek != MomentWeek ? 1 : 0;

        let weeksInYear = moment().isoWeeks();

        for (let weekNumber = 1; weekNumber < weeksInYear + 1; weekNumber++) {
            const startDay = moment()
                .week(weekNumber + hotfix)
                .startOf("week");
            const endDay = moment()
                .week(weekNumber + hotfix)
                .endOf("week");

            const week = {
                name: `Semana ${weekNumber}`,
                start: startDay.locale("pt-br").format("DD/MM/YYYY"),
                startFormatted: startDay.locale("pt-br").format("YYYY-MM-DD"),
                end: endDay.locale("pt-br").format("DD/MM/YYYY"),
                endFormatted: endDay.locale("pt-br").format("YYYY-MM-DD"),
            };

            this.weeks.push(week);
        }
    },

    methods: {
        setPage(data) {
            this.currentPage = data;
            this.fetchGalleries({
                ...this.filterData,
                limit: this.limit,
                page: data,
            });
        },
        filterGalleries(data) {
            this.filterData = data;
            this.fetchGalleries(data);
        },
        fetchGalleries(data) {
            const requestId = new Date().getTime();
            this.isLoadingPage = this.isLoadingPage.filter(
                (isLoadingObject) => isLoadingObject.requestId > requestId
            );
            this.isLoadingPage.push({
                requestId,
                loading: true,
            });
            axios.post("winners/filter", data).then((response) => {
                const lastRequest = this.isLoadingPage.find(
                    (isLoadingObject) => isLoadingObject.requestId === requestId
                );
                if (lastRequest) {
                    this.galleries = response?.data.galleries;
                    this.total = response?.data.total;

                    if (response.status == 200) {
                        this.isFiltered = true;
                    }
                }
            });
        },
        clearFilter() {
            window.location = "/winners";
        },
        showInModal(photos) {
            this.currentGallery = {
                exhibition: photos[0],
                photos: photos,
            };
        },
        loadPdv(pdv) {
            axios
                .get(`/pdv/${pdv.id}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];
                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
